import { Directive, TemplateRef, inject } from '@angular/core';

export interface BsItemContext<T> {
  $implicit: T;
  query: string;
  index: number;
  active: boolean;
}

export interface BsEmptyContext {
  query: string;
}

export interface BsFooterContext {
  query: string;
  itemsCount: number;
  loading: boolean;
}

@Directive({
  selector: '[bsItem]',
  standalone: true
})
export class BsItemDirective<T> {
  readonly templateRef = inject<TemplateRef<BsItemContext<T>>>(TemplateRef);

  static ngTemplateContextGuard<T>(
    _dir: BsItemDirective<T>,
    ctx: unknown
  ): ctx is BsItemContext<T> {
    return true;
  }
}

@Directive({
  selector: '[bsEmpty]',
  standalone: true
})
export class BsEmptyDirective {
  readonly templateRef = inject<TemplateRef<BsEmptyContext>>(TemplateRef);

  static ngTemplateContextGuard(
    _dir: BsEmptyDirective,
    ctx: unknown
  ): ctx is BsEmptyContext {
    return true;
  }
}

@Directive({
  selector: '[bsFooter]',
  standalone: true
})
export class BsFooterDirective {
  readonly templateRef = inject<TemplateRef<BsFooterContext>>(TemplateRef);

  static ngTemplateContextGuard(
    _dir: BsFooterDirective,
    ctx: unknown
  ): ctx is BsFooterContext {
    return true;
  }
}
